// extracted by mini-css-extract-plugin
export default {"wrapper":"ConfirmModal_wrapper__NZoOE","button":"ConfirmModal_button__dGCzg"};